import React, {useEffect, useState} from 'react';
import Slider, {SliderTooltip} from 'rc-slider';
import {useTranslation} from 'react-i18next';
import 'rc-slider/assets/index.css';

const {Handle} = Slider;


function Input(props) {
	const {t} = useTranslation();
	let {
		label = '',
		name = '',
		required = false,
		updateItem = () => {
		},
		item = {},
		isError = false,
		onValide = false,
		min = 10,
		max = 10,
		hide = false
	} = props;
	const [currentValue, setCurrentValue] = useState(typeof item[name] !== 'undefined' ? item[name] : max);

	let paramsInput = {}
	if ((isError || onValide) && required) {
		paramsInput = {
			required: true
		};
	}
	const handle = props => {
		const {value, dragging, index, ...restProps} = props;
		return (
			<SliderTooltip
				prefixCls="rc-slider-tooltip"
				overlay={`${value} %`}
				visible={dragging}
				placement="top"
				key={index}
			>
				<Handle value={value} {...restProps} >
					<div className="slider-value">
						{value}
					</div>
				</Handle>
			</SliderTooltip>
		);
	};

	useEffect(() => {
		if (typeof item[name] !== 'undefined') {
			setCurrentValue(item[name]);
		}
	}, [item]);

	if (hide) {
		return (null);
	}

	return (
		<div className={'mb-3' + (((isError || onValide) && required) ? ' was-validated' : '')}>
			<label className="form-label">
				{label} {required && (<span>*</span>)}
			</label>
			<Slider
				min={min}
				max={max}
				value={currentValue}
				handle={handle}
				onChange={(value) => {
					setCurrentValue(value);
				}}
				onAfterChange={(value) => {
					updateItem(name, value);
				}}
			/>
			<div className="invalid-feedback">{t('Form.required')}</div>
		</div>
	);
}

export default Input;
